module.exports = __webpack_public_path__ + "static/media/2.cfb6e3a4.png";